import { Card, money } from './dsfApi';

const pctClass = (p) => (p == null ? '' : p > 90 ? 'text-red-400' : p > 88 ? 'text-amber-300' : 'text-[#39FF14]');

export const DsfDailyCard = ({ data, days, setDays }) => (
    <Card title="Daily totals" testid="dsf-daily-card"
        right={[7, 30].map((d) => (
            <button key={d} type="button" onClick={() => setDays(d)} data-testid={`dsf-days-${d}`}
                className={`rounded-full px-3 py-1 text-xs font-bold ${days === d ? 'bg-[#39FF14] text-black' : 'bg-white/5 text-white/70'}`}>{d} days</button>
        ))}>
        {!data ? <p className="text-white/50">Loading…</p> : (
            <div className="overflow-x-auto">
                <table className="w-full text-sm text-[#cfd6dc]">
                    <thead><tr className="text-left text-[11px] uppercase tracking-wider text-[#A0AAB2]">
                        <th className="pb-2">Day</th><th className="pb-2 text-right">Players</th><th className="pb-2 text-right">Shots</th>
                        <th className="pb-2 text-right">Bets</th><th className="pb-2 text-right">Wins</th><th className="pb-2 text-right">Payback</th><th className="pb-2 text-right">Profit</th>
                    </tr></thead>
                    <tbody>
                        {data.daily.map((r) => (
                            <tr key={r.date} className="border-t border-white/5" data-testid={`dsf-day-${r.date}`}>
                                <td className="py-1.5">{r.date}</td><td className="text-right">{r.players}</td><td className="text-right">{r.shots}</td>
                                <td className="text-right tabular-nums">{money(r.bets)}</td><td className="text-right tabular-nums">{money(r.won)}</td>
                                <td className={`text-right font-bold ${pctClass(r.payback_pct)}`}>{r.payback_pct == null ? '—' : `${r.payback_pct}%`}</td>
                                <td className={`text-right font-bold tabular-nums ${r.profit < 0 ? 'text-red-400' : 'text-[#39FF14]'}`}>{money(r.profit)}</td>
                            </tr>
                        ))}
                    </tbody>
                    <tfoot><tr className="border-t-2 border-white/20 font-black text-white" data-testid="dsf-daily-total">
                        <td className="pt-2">Total</td><td /><td className="pt-2 text-right">{data.total.shots}</td>
                        <td className="pt-2 text-right">{money(data.total.bets)}</td><td className="pt-2 text-right">{money(data.total.won)}</td>
                        <td className={`pt-2 text-right ${pctClass(data.total.payback_pct)}`}>{data.total.payback_pct == null ? '—' : `${data.total.payback_pct}%`}</td>
                        <td className={`pt-2 text-right ${data.total.profit < 0 ? 'text-red-400' : 'text-[#39FF14]'}`}>{money(data.total.profit)}</td>
                    </tr></tfoot>
                </table>
                <p className="mt-2 text-xs text-white/40">Business day 7:00 AM → 7:00 AM Central. Bets are after shot refunds.</p>
            </div>
        )}
    </Card>
);
